import { multiCompareFunction } from './array/compareFunction'

const toOrdering = (x: number): Ordering => {
  if (x < 0) {
    return -1
  }
  if (x > 0) {
    return 1
  }
  return 0
}

const orderNullalbe = (a: unknown, b: unknown) => {
  const rankA = a === null ? 1 : a === undefined ? 2 : 0
  const rankB = b === null ? 1 : b === undefined ? 2 : 0
  return toOrdering(rankA - rankB)
}

export const compareFunction = (a: unknown, b: unknown): Ordering => {
  if (typeof a === 'number' && typeof b === 'number') {
    return toOrdering(a - b)
  }
  if (typeof a === 'string' && typeof b === 'string') {
    return toOrdering(a.localeCompare(b))
  }
  if (a === undefined || b === undefined || a === null || b === null) {
    return orderNullalbe(a, b)
  }

  return toOrdering(JSON.stringify(a).localeCompare(JSON.stringify(b)))
}

export function isSome<T>(x: T): x is Exclude<T, undefined | null> {
  return x !== undefined && x !== null
}

export function isNull(x: unknown): x is undefined | null {
  return !isSome(x)
}

export function isPresent<T>(x: T): x is Exclude<T, undefined | null> {
  if (isNull(x)) {
    return false
  }
  if (typeof x === 'string') {
    return x !== ''
  }
  if (Array.isArray(x)) {
    return x.length > 0
  }

  return true
}

// null,undefined,falseのときにfalse
export function isTruthy(x: unknown): boolean {
  if (isNull(x) || x === false) {
    return false
  }
  return true
}

// es-toolkitのcompactはfalsyな値（0や''など）を全て除去してしまうため、
// null/undefinedのみを除去する従来の挙動を維持する独自実装を残している
export function compact<T>(xs: T[]): Array<Exclude<T, undefined | null>> {
  return xs.filter((x) => isSome(x))
}

type Ordering = -1 | 0 | 1

// es-toolkitのsortByとは比較の仕様が異なる（localeCompareによる文字列比較・null/undefinedの末尾送り・
// mapperが配列を返した場合の多段キー比較）ため、従来のプロトタイプ拡張版sortByと同一の挙動を関数として残している
export const sortBy = <T>(xs: T[], f: (x: T) => unknown): T[] => {
  return [...xs].sort((a, b) => {
    const aKey = f(a)
    const bKey = f(b)
    if (Array.isArray(aKey) && Array.isArray(bKey)) {
      return multiCompareFunction(aKey, bKey)
    }
    return compareFunction(aKey, bKey)
  })
}

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export function parseJsonIfValid(x: string): unknown | undefined {
  try {
    return JSON.parse(x) as unknown
  } catch (_e) {
    return undefined
  }
}
